import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { Author } from "../basic/author.js";
import { getSocialCardsTemplate } from "./social-share.js";
import { SocialShare } from "@quintype/components";
import {storyColor, sectionPath} from '../../utils';

class StoryHeaderCard extends React.Component {
  render() {
    const color = storyColor(this.props.config, this.props.story);

    const sectionColor = {
      borderBottomColor: color
    };
    const liveDisplayStyles = {
      backgroundColor : color
    }
    const tagsArray = this.props.story.tags.reduce((acc, item) => {
      acc.push(item.name)
      return acc;
    }, [])
    const stringifiedTagsArray = tagsArray.toString();
    const socialShareMessage = !isEmpty(this.props.story.summary) ? this.props.story.summary : this.props.story.headline;
    const authorsArray = get(this.props.story, ['authors'])
                          ? get(this.props.story, ['authors'])
                          : [{
                            name: this.props.story['author-name'],
                            id: this.props.story['author-id']
                          }];
    const sponsoredContent = get(this.props,['story', 'metadata','sponsored-by']);

    return <header className="story-header">
     { sponsoredContent && <p className="sponsored-story">Sponsored by {sponsoredContent}</p>}
      <Link className="story-section"
        href={"/" + sectionPath(this.props.config, this.props.story.sections[0])}
        style={sectionColor}>
        {this.props.story.sections[0]['display-name'] || this.props.story.sections[0]['name'] }
      </Link>
      <div>
        { (this.props.story['story-template'] === "live-blog") && 
          <div className="live-story-wrapper">
            <span className="live-story" style={liveDisplayStyles}>live</span>
          </div>   
        }
        <h1 className="story-headline"><bdi dangerouslySetInnerHTML={ {__html: this.props.story.headline }}></bdi></h1>
      </div>
      <p className="story-summary"><bdi dangerouslySetInnerHTML={ {__html: this.props.story.subheadline }}></bdi></p>
      <div className="story-byline">
        <div className="story-byline__author_time">
        <Author config={this.props.config} authors={authorsArray} isLink showDateOnly date={this.props.story['first-published-at']}/>
        </div>
        <div className="story-byline__social-share">
          <SocialShare url={this.props.story.slug}
            title={socialShareMessage}
            template={getSocialCardsTemplate}
            hashtags={stringifiedTagsArray} />
        </div>
      </div>
    </header>
  }
}

export { StoryHeaderCard };
